export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  error: false,
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    isFetching: false,
    error: false,
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: action.errData,
    isFetching: false,
    error: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_LOGIN_V2_REQUESTED":
      return request(state, action);
    case "REQ_LOGIN_V2_SUCCEEDED":
      return success(state, action);
    case "REQ_LOGIN_V2_FAILED":
      return failure(state, action);
    case "RESET_LOGIN_V2":
      return INITIAL_STATE;
    default:
      return state;
  }
};
